define("settings/templates/groups/group/meta_ad_accounts", ["exports", "@ember/template-factory"], function (_exports, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <MetaAdAccountsCard::GroupAdAccountsTab @group={{this.model.group}} />
  */
  {
    "id": "XxEwwFtg",
    "block": "[[[8,[39,0],null,[[\"@group\"],[[30,0,[\"model\",\"group\"]]]],null]],[],false,[\"meta-ad-accounts-card/group-ad-accounts-tab\"]]",
    "moduleName": "settings/templates/groups/group/meta_ad_accounts.hbs",
    "isStrictMode": false
  });
});